import React from 'react';

// Material UI
import {Grid} from "@mui/material";

// Components
import CancelledTitle from "components/WMS/Mobile/WmsItemListTitle/CancelledTitle";
import MobileItem from "components/WMS/Mobile/MobileItem";
import LineItemOptionList from "components/WMS/Mobile/WmsItemList/components/LineItemOptionList";
import WmsItemCodes from "components/WMS/Mobile/WmsItemList/components/WmsItemCodes";
import WmsItemPlaceList from "components/WMS/Mobile/WmsItemList/components/WmsItemPlaceList";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import VariationCount from "components/WMS/Mobile/WmsItemList/components/VariationCount";

// Contexts
import {WMSContext} from "views/wms/context/WMSContext";

function CancelledItemList({wmsItems, itemsCancelled = 0, onItemClick = () => {}}) {
    if (itemsCancelled === 0) {
        return null;
    }

    const { groupWmsItemsBySku } = React.useContext(WMSContext);

   return (
       <div>
           <CancelledTitle />
           {groupWmsItemsBySku(wmsItems).map((item, index) => (
               <MobileItem onClick={() => onItemClick(item)} key={index}>
                   <MobileItem.LeftSide
                       title={item.lineItem.name}
                       subtitle={<LineItemOptionList options={item.lineItem?.options} />}
                       underTitle={
                           <Grid container>
                               <WmsItemCodes wmsItem={item} />
                               <WmsItemPlaceList wmsItem={item} />
                           </Grid>
                       }
                   >
                       <ThumbnailAndNotification
                           link={item.lineItem.pictures?.[0]}
                           alt={item.lineItem.name}
                           unavailable={true}
                       >
                       </ThumbnailAndNotification>
                   </MobileItem.LeftSide>
                   <MobileItem.RightSide>
                       <VariationCount
                           count={itemsCancelled}
                           maxCount={itemsCancelled}
                           maxAchieveColor={'error'}
                       />
                   </MobileItem.RightSide>
               </MobileItem>
           ))}
       </div>
   )
}

export default CancelledItemList;
